import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

import appConfig from 'app-config';

const isGPA = appConfig.portalCode === 'GPA';

export default {
    getPropertyValuationInfoMLByJobNumber(request, additionalHeaders = {}) {
        const serviceName = isGPA ? 'gatewaypropertyvaluation' : 'propertyvaluation';
        return JsonRPCService.send(getProxiedServiceUrl(serviceName), 'getPropertyValuationInfoMLByJobNumber', [request], additionalHeaders);
    },
    getImageryLinkByQuoteNumber(request, additionalHeaders = {}) {
        const serviceName = isGPA ? 'gatewaypropertyvaluation' : 'propertyvaluation';
        return JsonRPCService.send(getProxiedServiceUrl(serviceName), 'getImageryLinkByQuoteNumber', [request], additionalHeaders);
    },
    getImageryLinkByPolicyNumber(request, additionalHeaders = {}) {
        const serviceName = isGPA ? 'gatewaypropertyvaluation' : 'propertyvaluation';
        return JsonRPCService.send(getProxiedServiceUrl(serviceName), 'getImageryLinkByPolicyNumber', [request], additionalHeaders);
    }
};
